import React from 'react';
import ProcessingIndicator from './ProcessingIndicator';

const LoadingState = ({ complete, errors, render, processingMessage, errorMessage }) => {
  const renderLoading = () => {

    return (
      <>
        {!complete && (
          <div className="parkchirp--page--user-message-container">
            <ProcessingIndicator userMessage={processingMessage} />
          </div>
        )}
        {errors.length > 0 && (
          <div className="parkchirp--page--user-message-container">
            <div className="parkchirp--page--user-message">
              <p>{errorMessage}</p>
              <ul>
                {errors.map(error =>
                  <li key={performance.now()}>{error}</li>
                )}
              </ul>
            </div>
          </div>
        )}
      </>
    )
  }
  return (
    <>
      {(!complete || errors.length > 0) ? renderLoading() : render()}
    </>
  );
};

export default LoadingState;